// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b37dc149","455":"73f0efa1","977":"fc306d97"}[chunkId] + ".chunk.js";
};